import { IComponentOptions } from "angular";
import { ContractMasterAgreementEditComponentController } from "./controller";

export const vsComponentName = "contractMasterAgreementEditComponent";

export const contractMasterAgreementEditComponentOptions: IComponentOptions = {
  template: require("!html-loader!./index.html").default,
  controller: ContractMasterAgreementEditComponentController,
  controllerAs: "editController",
  bindings: {
    contract: "<",
    contractType: "<",
  },
};
